import _implicitStylesheets from "./contentSection.css";
import _implicitScopedStylesheets from "./contentSection.scoped.css?scoped=true";
import _mfeContentCard from "mfe/contentCard";
import _aceButton from "ace/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h2${3}>${"t1"}</h2>`;
const stc0 = {
  classMap: {
    "axwp-post-feed__section": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "axwp-post-feed": true
  },
  key: 3
};
const stc2 = {
  classMap: {
    "axwp-post-feed__more": true
  },
  key: 5
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, c: api_custom_element, i: api_iterator, h: api_element, b: api_bind} = $api;
  const {_m0} = $ctx;
  return [$cmp.hasPosts ? api_element("div", stc0, [api_static_fragment($fragment1, 2, [api_static_part(1, null, api_dynamic_text($cmp.section.plural))]), api_element("div", stc1, api_iterator($cmp.posts, function (post) {
    return api_custom_element("mfe-content-card", _mfeContentCard, {
      props: {
        "cardTitle": post.title.rendered,
        "cardExcerpt": post.excerpt.rendered,
        "cardImage": post.featured_media_url,
        "cardLink": post.link,
        "badgeText": post.read_time,
        "tagText": post.content_type.singular,
        "tagLink": post.content_type.slug
      },
      key: api_key(4, post.id)
    });
  })), api_element("div", stc2, [!$cmp.filtered ? api_custom_element("ace-button", _aceButton, {
    props: {
      "label": $cmp.labels.homeExploreMore,
      "variant": "tertiary",
      "icon": "arrowdown",
      "iconPosition": "end"
    },
    key: 6,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.moreClicked))
    }
  }) : null])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-6j4jon25eda";
tmpl.legacyStylesheetToken = "undefined-_contentSection";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
